import { 
    LIST_LEAD_PENDING, LIST_LEAD_FULFILLED, LIST_LEAD_REJECTED,
    LIST_TASK_PENDING, LIST_TASK_FULFILLED, LIST_TASK_REJECTED
} from './LeadConstants'


const INITIAL_STATE = {
    leads: { pending: false, fulfilled: false, error: null, list:[] },
    task: { pending: false, fulfilled: false, error: null, list:[] },
}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {

        case LIST_LEAD_PENDING:
            return {...state, leads:{ ...state.leads, pending: true, fulfilled: false } }
        case LIST_LEAD_FULFILLED:
            return {...state, leads:{ ...state.leads, pending: false, fulfilled: true, list:action.payload.data } }
        case LIST_LEAD_REJECTED:
            return {...state, leads:{ ...state.leads, pending: false, error: action.payload.response } }


        case LIST_TASK_PENDING:
            return {...state, task:{ ...state.task, pending: true, fulfilled: false } }
        case LIST_TASK_FULFILLED:
            return {...state, task:{ ...state.task, pending: false, fulfilled: true, list:action.payload.data } }
        case LIST_TASK_REJECTED:
            return {...state, task:{ ...state.task, pending: false, error: action.payload.response } }

        // DEFAULT
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/lead/LeadReducer.js